import React from 'react';

import { CellRenderer, MainColumns } from '../../../../components/TableGrid';
import HistoricalTable from '../../../../components/Tables/historicalTable';
import { SearchCriteria } from '../../../../generated/model/searchCriteria';

export interface Props {
  data: SearchCriteria[];
  withCounts?: boolean;
}

export const SearchSummaryDataTable: React.FC<Props> = ({ data, withCounts = true }) => {
  return (
    <HistoricalTable
      columns={withCounts ? cols : colsWithoutCounts}
      translationsScope={'searchSummary:columns'}
      rows={data}
    />
  );
};

const cols: MainColumns[] = [
  { field: 'no', maxWidth: 70 },
  { field: 'criteriaName', maxWidth: 600, unSortIcon: true },
  { field: 'stepCount', maxWidth: 120, unSortIcon: true, cellRenderer: CellRenderer.Number },
  { field: 'searchCount', unSortIcon: true, cellRenderer: CellRenderer.Number },
];

const colsWithoutCounts: MainColumns[] = [
  { field: 'no', maxWidth: 70 },
  { field: 'criteriaName', unSortIcon: true },
];
